// Журнал действий: только чтение (тз, разделы 3.1 и 8.5).
//
// Записать в журнал из программы нельзя и не будет можно: журнал пишется самими действиями,
// в их же транзакции. Запись, которую можно поставить снаружи, обесценивает весь журнал.

import { request } from '@/shared/api/client';
import { queryString } from '@/shared/api/query';

export interface AuditEntry {
  /** Номер записи: плотный и возрастающий, по нему листают. */
  id: number;
  at: string;
  user_id?: string | null;
  /** Имя учётной записи на СЕГОДНЯ: человека могли переименовать после действия. */
  user_name?: string | null;
  entity: string;
  entity_id?: string | null;
  entity_ref?: string | null;
  /**
   * Что именно изменено, словами: «Выдача 12 000 ₽ · Вихрев Сергей · 12.10.2026». Сервер
   * собирает его при чтении по самой записи, поэтому он есть и у старых строк журнала;
   * пусто, если вид записи не описан.
   */
  subject?: string | null;
  action: string;
  field?: string | null;
  old_value?: string | null;
  new_value?: string | null;
  basis?: string | null;
  request_id?: string | null;
  scope_note?: string | null;
}

export interface AuditPage {
  items: AuditEntry[];
  total: number;
  generated_at: string;
}

export interface AuditParams {
  entity?: readonly string[];
  entity_id?: string;
  action?: readonly string[];
  user_id?: string;
  since?: string;
  until?: string;
  /** Курсор: «дай записи старше этого номера». Смещения здесь нет намеренно. */
  before_id?: number;
  limit?: number;
}

export async function fetchAudit(params: AuditParams = {}): Promise<AuditPage> {
  return request<AuditPage>(`/api/v1/audit${queryString({ ...params })}`);
}
